import serverApi from "../utils/serverApi"

const swapTokensService = {
  createSwapTokenTransaction: (body) => serverApi({
    uri: "swap-token-transactions/create",
    method: "POST",
    data: body
  }),

  getSwapTokenTransaction: (body) => serverApi({ uri: "swap-token-transactions/get", method: "POST", data: body }),

}

export default swapTokensService
